import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import MoodBadIcon from "@mui/icons-material/MoodBad";
import { Card, IconButton, Stack, Typography } from "@mui/material";
import { AppChip, DeleteIconButton } from "../../../../components/form";
import { ProductIcon } from "../../../../components/icons";
import FlexBox from "../../../../components/layouts/Flexbox";
import { APP_COLORS, APP_FONT_FAMILIES } from "../../../../enums";
import { PencilSimple } from "@phosphor-icons/react";

function ProductBlock({ data, editable, onEditClick, onDeleteClick, deleteLoading = false }) {
  return (
    <Card>
      <Stack gap={1}>
        <FlexBox alignItems="center">
          <FlexBox alignItems="center">
            <ProductIcon />
            <Typography
              variant="body-mono-medium"
              className="truncated-text"
              title={data?.category}
            >
              {data?.category}
            </Typography>
          </FlexBox>
        </FlexBox>
        <FlexBox alignItems="center" gap={1} justifyContent="space-between">
          <AppChip
            label={data?.isSatisfied ? "Satisfied" : "Unsatisfied"}
            size="small"
            icon={
              data?.isSatisfied ? (
                <InsertEmoticonIcon color="success" sx={{ color: APP_COLORS.successDark3 }} />
              ) : (
                <MoodBadIcon color="error" sx={{ color: APP_COLORS.errorDark3 }} />
              )
            }
            sx={{
              color: data?.isSatisfied
                ? APP_COLORS.successDark3
                : APP_COLORS.errorDark3,
              bgcolor: data?.isSatisfied
                ? APP_COLORS.successLight2
                : APP_COLORS.errorLight2,
              fontFamily: APP_FONT_FAMILIES.ibmPlexMono,
            }}
          />
          <FlexBox alignItems="center">
            <IconButton
              onClick={() => {
                onEditClick();
              }}
              sx={{
                visibility: editable ? "visible" : "hidden",
                p: 0,
                verticalAlign: "middle",
              }}
            >
              <PencilSimple size={20} />
            </IconButton>

            <DeleteIconButton onClick={onDeleteClick} loading={deleteLoading} />
          </FlexBox>
        </FlexBox>
      </Stack>
    </Card>
  );
}

export default ProductBlock;
